import { Wallet, CheckCircle2 } from "lucide-react";
import PendingPartnerPaymentsCard from "../components/PendingPartnerPaymentsCard";
import { useAuth } from "../lib/auth";
import { Link } from "react-router-dom";

/**
 * Dedicated Founder page for pending partner payments approvals.
 *
 * Partners log payments via `/partner-portal/payments` with status
 * "unverified".  Until the Founder approves each one here, the payment
 * DOES NOT reduce the partner's due balance — it just sits in the
 * "pending" bucket on the Revenue Ledger.  Once approved, the amount
 * flows into `paid` and the balance recalculates automatically.
 */
export default function PendingPayments() {
  const { user } = useAuth();
  const role = user?.real_role || user?.effective_role;
  if (role !== "FOUNDER" && role !== "BDOM") {
    return (
      <div className="aii-card p-6 text-sm text-[color:var(--aii-muted)]">
        Only the Founder / BDOM can approve partner payments.
      </div>
    );
  }
  return (
    <div className="space-y-4" data-testid="pending-payments-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-brand font-bold flex items-center gap-1.5">
          <Wallet size={11}/> Pending Partner Payments
        </div>
        <h1 className="text-2xl font-display font-semibold mt-0.5">Approvals queue</h1>
        <p className="text-sm text-[color:var(--aii-text-2)] mt-1 max-w-2xl">
          Every payment a partner logged that&apos;s awaiting your approval.
          A payment does NOT reduce the partner&apos;s outstanding balance
          until you verify it — approve here and the <Link to="/partner-payments" className="text-brand underline decoration-dotted">Revenue Ledger</Link> updates instantly.
        </p>
      </div>
      <div className="aii-card p-4 flex items-start gap-2 bg-sky-50 border-sky-200">
        <CheckCircle2 size={14} className="text-sky-700 mt-0.5 shrink-0"/>
        <div className="text-xs text-sky-900">
          <b>Workflow:</b> Attribute a payment to the correct booking (optional but recommended) → Verify.
          Rejected payments stay on the audit trail but are excluded from every balance calculation.
        </div>
      </div>
      <PendingPartnerPaymentsCard/>
    </div>
  );
}
